var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBingAdsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    role: "img",
    "aria-label": "Bing Ads",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#008272",
    points: "19.7,25.3 26.4,42 37,46.9 15.4,59.4 15.4,5.4 0,0 0,68.2 15.4,76.8 53.8,54.7 53.8,37.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBingAdsIcon);
export default __webpack_public_path__ + "static/media/Bing_Ads_icon.b97847935791dba75c24b35eeef4a00e.svg";
export { ForwardRef as ReactComponent };